export const formatScoreFormatTitle = (scoreFormatTitle: string | null): string => {
	if (!scoreFormatTitle) return '';

	// Generic pattern: e.g. "2 games guaranteed - All 2 games to 11 win by 1"
	const guaranteedRegex = /^(\d+)\s+games guaranteed\s*-\s*All\s*\d+\s*games to\s*(\d+)\s*win by\s*(\d+)/i;
	const guaranteedMatch = scoreFormatTitle.match(guaranteedRegex);

	if (guaranteedMatch) {
		const guaranteed = guaranteedMatch[1];
		const to = guaranteedMatch[2];
		const by = guaranteedMatch[3];
		return `Guaranteed ${guaranteed} to ${to} by ${by}`;
	}

	// If no keywords to shorten, return as is
	if (!scoreFormatTitle.includes('out of') && !scoreFormatTitle.includes('All games to')) {
		return scoreFormatTitle;
	}

	// Shorten common phrases
	return scoreFormatTitle.replace('out of', 'of').replace('All games to', 'all to').replace('win by', 'by').trim();
};
